import { Component, Input } from '@angular/core';
import { DeviceResponseDto } from '../../models/device-response.interface';
import { CardComponent } from '../../../../shared/components/card/card.component';
import {
  IconComponent,
  IconSize,
} from '../../../../shared/icons/icon.component';
import { IconsPipe } from '../../../../shared/pipes/icons.pipe';
import { RelativeDatePipe } from '../../../../shared/pipes/relative-date.pipe';
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { DeviceValueUnit } from '@birco/rainmesh-api';
import { LabelConverter } from '../../../../shared/converter/label.converter';
import { LocalizedNumberPipe } from '../../../../shared/pipes/localized-number.pipe';
import { LocalizedPercentPipe } from '../../../../shared/pipes/localized-percent.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { getDeviceDetailRoute } from '../../../../shared/utils/device-route.util';

@Component({
  selector: 'app-device-reduced-dashboard-card',
  imports: [
    CardComponent,
    IconComponent,
    IconsPipe,
    RouterLink,
    RelativeDatePipe,
    LocalizedNumberPipe,
    LocalizedPercentPipe,
    TranslatePipe,
  ],
  templateUrl: './device-reduced-dashboard-card.component.html',
  styleUrl: './device-reduced-dashboard-card.component.scss',
})
export class DeviceReducedDashboardCardComponent {
  @Input() device!: DeviceResponseDto;

  protected readonly RouteConstants = RouteConstants;
  protected readonly getDeviceDetailRoute = getDeviceDetailRoute;
  protected readonly DeviceValueUnit = DeviceValueUnit;
  protected readonly LabelConverter = LabelConverter;
  protected readonly Number = Number;
  protected readonly IconSize = IconSize;
}
